/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_Ar as Ar,
  rec_AvatarPersona as AvatarPersona,
  rec_C0 as C0,
  rec_FiltroColumna as FiltroColumna,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_T0 as T0,
  rec_hr as hr,
  rec_kx as kx,
  rec_qr as qr,
  rec_vr as vr,
} from "../../runtime/index.jsx";
export function Componente_A0_65_48(e) {
  let t = (0, ReactCompiler.c)(39),
    {
      col: n,
      indice: r,
      activa: i,
      izquierda: a,
      orden: o,
      filtrada: s,
      abierto: c,
      onAbrir: l,
      onCerrar: u,
      valores: f,
      permitidos: p,
      onOrdenar: m,
      onFiltrar: h,
    } = e,
    _ = (0, React.useRef)(null),
    v;
  (t[0] === u ? (v = t[1]) : ((v = () => u()), (t[0] = u), (t[1] = v)),
    kx(c, _, v));
  let y = s || o,
    b = o === `asc` ? `ascending` : o === `desc` ? `descending` : `none`,
    x = n.color ? `linear-gradient(${n.color}, ${n.color}), var(--bg)` : void 0,
    S;
  t[2] !== a || t[3] !== x
    ? ((S = {
        height: T0,
        left: a,
        background: x,
      }),
      (t[2] = a),
      (t[3] = x),
      (t[4] = S))
    : (S = t[4]);
  let C = `sticky top-0 border-r border-b border-(--border) bg-(--bg) px-2 text-left align-bottom font-medium text-(--text-h) ${a === void 0 ? `z-20` : `z-30`}`,
    w = `-mx-2 block px-2 text-[10px] ${i ? `bg-(--accent-bg) font-semibold text-(--text-h)` : `font-normal text-(--text)`}`,
    T;
  t[5] === r ? (T = t[6]) : ((T = C0(r)), (t[5] = r), (t[6] = T));
  let E;
  t[7] !== w || t[8] !== T
    ? ((E = <span className={w} children={T} />),
      (t[7] = w),
      (t[8] = T),
      (t[9] = E))
    : (E = t[9]);
  let D;
  t[10] === n.titulo
    ? (D = t[11])
    : ((D = (
        <span className={`truncate`} title={n.titulo} children={n.titulo} />
      )),
      (t[10] = n.titulo),
      (t[11] = D));
  let O = `Ordenar y filtrar ${n.titulo}`,
    k = `ml-auto shrink-0 rounded border p-0.5 ${y ? `border-(--accent) bg-(--accent-bg) text-(--accent)` : `border-(--border) text-(--text) hover:text-(--text-h)`}`,
    A;
  t[12] !== s || t[13] !== o
    ? ((A = s ? (
        (0, JSXRuntime.jsx)(qr, {
          className: `h-3 w-3`,
        })
      ) : o === `asc` ? (
        (0, JSXRuntime.jsx)(hr, {
          className: `h-3 w-3`,
        })
      ) : o === `desc` ? (
        (0, JSXRuntime.jsx)(vr, {
          className: `h-3 w-3`,
        })
      ) : (
        <Ar className={`h-3 w-3`} />
      )),
      (t[12] = s),
      (t[13] = o),
      (t[14] = A))
    : (A = t[14]);
  let j;
  t[15] !== c || t[16] !== l || t[17] !== O || t[18] !== k || t[19] !== A
    ? ((j = (
        <button
          type={`button`}
          aria-label={O}
          aria-expanded={c}
          onClick={l}
          className={k}
          children={A}
        />
      )),
      (t[15] = c),
      (t[16] = l),
      (t[17] = O),
      (t[18] = k),
      (t[19] = A),
      (t[20] = j))
    : (j = t[20]);
  let M;
  t[21] !== j || t[22] !== D
    ? ((M = (
        <span className={`flex items-center gap-1 pb-1`} children={[D, j]} />
      )),
      (t[21] = j),
      (t[22] = D),
      (t[23] = M))
    : (M = t[23]);
  let N;
  t[24] !== c ||
  t[25] !== n.titulo ||
  t[26] !== u ||
  t[27] !== h ||
  t[28] !== m ||
  t[29] !== p ||
  t[30] !== f
    ? ((N = c && (
        <AvatarPersona
          anclaRef={_}
          anchoMinimo={260}
          className={`rounded-2xl border border-(--border) bg-(--bg) p-2 font-normal shadow-2xl`}
          children={
            <FiltroColumna
              valores={f}
              permitidos={p}
              onOrdenar={(e) => {
                (m(e), u());
              }}
              onFiltrar={h}
              titulo={n.titulo}
            />
          }
        />
      )),
      (t[24] = c),
      (t[25] = n.titulo),
      (t[26] = u),
      (t[27] = h),
      (t[28] = m),
      (t[29] = p),
      (t[30] = f),
      (t[31] = N))
    : (N = t[31]);
  let P;
  return (
    t[32] !== M ||
    t[33] !== N ||
    t[34] !== b ||
    t[35] !== S ||
    t[36] !== C ||
    t[37] !== E
      ? ((P = (
          <th
            ref={_}
            role={`columnheader`}
            aria-sort={b}
            style={S}
            className={C}
            children={[E, M, N]}
          />
        )),
        (t[32] = M),
        (t[33] = N),
        (t[34] = b),
        (t[35] = S),
        (t[36] = C),
        (t[37] = E),
        (t[38] = P))
      : (P = t[38]),
    P
  );
}
